export default __webpack_public_path__ + "static/media/7.2cd741b0.png";